import { useEffect, useState } from 'react';
import { getTiflePolicies } from 'services/api';
import styled from 'styled-components';

export const Root = styled.div`
  background: white;
  color: #818181;
  .header {
    background-color: ${({ theme }) => theme.colors.primary};
    padding: 20px;
    h2 {
      color: white;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
  .wrapper {
    padding: 20px;
    .content {
      border: 1px solid ${({ theme }) => theme.colors.primary};
      padding: 15px;
      overflow-y: scroll;
      max-height: calc(100vh - 350px);
      &::-webkit-scrollbar-track {
        background-color: ${(props) => props.theme.colors.white};
      }
      &::-webkit-scrollbar {
        background-color: ${(props) => props.theme.colors.white};
        width: 1rem;
        border-left: 1px solid;
      }
      &::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.theme.colors.primary};
      }
    }
  }
`;

const TermsOfService = () => {
  const [tos, setTos] = useState('');

  useEffect(() => {
    getTiflePolicies({ name: 'Tifle Terms of Service - Receive Only' }).then(
      (res: any) => {
        if (res) {
          setTos(res.Tifle_Policies_Desc);
        }
      },
    );
  }, []);

  return (
    <Root>
      <div className="header">
        <h2>Terms of Service</h2>
      </div>
      <div className="wrapper">
        <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: tos.replaceAll('\n', '<br />').replaceAll('”', '"'),
          }}
        />
      </div>
    </Root>
  );
};

export default TermsOfService;
